import { render, staticRenderFns } from "./ConfirmEmailForm.vue?vue&type=template&id=b49eaf0c&scoped=true&"
import script from "./ConfirmEmailForm.vue?vue&type=script&lang=ts&"
export * from "./ConfirmEmailForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmEmailForm.vue?vue&type=style&index=0&id=b49eaf0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49eaf0c",
  null
  
)

export default component.exports